import React from 'react';
import {classes, st} from './PaymentRequestItemSection.st.css';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor';
import {PaymentRequestItem} from '../PaymentRequestItem/PaymentRequestItem';
import {SPECS} from '../../../../common/constants';

export enum PaymentRequestItemSectionDataHooks {
  root = 'PaymentRequestItemSectionDataHooks.root',
}

export const PaymentRequestItemSection = () => {
  const localeKeys = useLocaleKeys();
  const {isMobile} = useEnvironment();
  const {experiments} = useExperiments();
  const shouldShowDividers = experiments.enabled(SPECS.ShowDividersInPaymentRequestSummary);

  return (
    <section
      className={shouldShowDividers ? classes.section : /* istanbul ignore next */ undefined}
      data-hook={PaymentRequestItemSectionDataHooks.root}
      aria-label={localeKeys.checkout.orderSummary.fullSection.ariaLabel()}>
      <ul className={st(classes.itemsList, isMobile ? classes.itemsListMobile : undefined)}>
        <PaymentRequestItem useLayoutForLongPrice={false} />
      </ul>
    </section>
  );
};
